module.exports = __webpack_public_path__ + "static/img/icon3-6.eebf5ca4.png";